import find from 'lodash/find';

function getLocation(club, locationId) {
  if (locationId) {
    return find(club.locations, { id: locationId });
  }
  if (club.locations.length === 1) {
    return club.locations[0];
  }
  return undefined;
}

export default getLocation;
